import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import KpiRemesaConvenio from './KpiRemesaConvenio';
import KpiRemesaFuvex from './KpiRemesaFuvex';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import KpiRemesaPie from './KpiRemesaPie';
import CurvaProduccionRemesa from '../curva-produccion/CurvaProduccionRemesa';
import Title from '../../../components/admin/Title';

const KpiRemesa: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const title = 'KPI - Remesa';
  const [factConvenioBar, setFactConvenioBar] = useState({
    labels: [],
    values: [],
  });
  const [fuvex, setFuvex] = useState({
    data: [],
    resume: {
      facturacion: 0,
      mejorMesDia: 0,
      mejorMes: 0,
      comparativo: 0,
      avance: 0,
    },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [jfn, setJfn] = useState({
    data: [],
    resume: {
      facturacion: 0,
      mejorMesDia: 0,
      mejorMes: 0,
      comparativo: 0,
      avance: 0,
    },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({
    year: null,
    month: null,
    bestMonth: 0,
    bestMonthPrev: 0,
    bestMonthDay: '',
  });
  const [headerResponse, setHeaderResponse] = useState({
    bestMonth: 0,
    bestMonthPrev: 0,
    bestMonthDay: '',
    currentDate: '',
  });
  const [detailByState, setDetailByState] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState({ pesoRemesa: [], pesoARemesa: [], fcstRemesa: [], fcstARemesa: [], realRemesa: [], realARemesa: [], caidaRemesa: [], caidaARemesa: [], avanceRemesa: [] });

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/kpi-remesa',
        body: { ...values, limit: defaultLimit },
      });
      const bestMonth = response?.header.bestMonth || 0;
      const bestMonthPrev = response?.header.bestMonthPrev || 0;
      const bestMonthDay = response?.header.bestMonthDay || '';
      setDetailByState(response?.detailByState);
      setHeaderResponse(response?.header);
      setFactConvenioBar(response?.factConvenioBar);
      setFuvex(response?.fuvex);
      setJfn(response?.jfn);
      setHeaders(response?.curve?.headersRemesa);
      setData(response?.curve);
      setValuesFilter((item) => ({
        ...item,
        bestMonth,
        bestMonthPrev,
        bestMonthDay,
      }));
    }
  };

  const handleChangePageFuvex = async (event: unknown, page: number) => {
    const { year, month, bestMonth, bestMonthPrev, bestMonthDay } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-remesa/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthPrev,
        bestMonthDay,
        limit: Number(fuvex.pages.limit),
        page,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  const handleChangeRowsPerPageFuvex = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month, bestMonth, bestMonthPrev, bestMonthDay } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-remesa/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthPrev,
        bestMonthDay,
        limit: Number(event.target.value),
        page: 0,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  const handleChangePageJfn = async (event: unknown, page: number) => {
    const { year, month, bestMonth, bestMonthPrev, bestMonthDay } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-remesa/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthPrev,
        bestMonthDay,
        limit: Number(jfn.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPageJfn = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month, bestMonth, bestMonthPrev, bestMonthDay } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-remesa/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthPrev,
        bestMonthDay,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Box pt={3}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <KpiRemesaConvenio content={factConvenioBar} />
              <KpiRemesaPie content={detailByState} />
            </Grid>
            <Grid item xs={12} md={7}>
              <KpiRemesaFuvex
                fuvex={fuvex}
                jfn={jfn}
                values={valuesFilter}
                header={headerResponse}
                handleChangePageFuvex={handleChangePageFuvex}
                handleChangeRowsPerPageFuvex={handleChangeRowsPerPageFuvex}
                handleChangePageJfn={handleChangePageJfn}
                handleChangeRowsPerPageJfn={handleChangeRowsPerPageJfn}
              />
            </Grid>
            <Grid item xs={12}>
              <Title title="Curva Producción - REMESA" />
              <CurvaProduccionRemesa headers={headers} data={data} />
            </Grid>
          </Grid>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(KpiRemesa);
